import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import AgentPaymentService from "../../services/agent/AgentPaymentService";
export const AgentPaymentContext = createContext("AgentPaymentContext");

const AgentPaymentContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [agentPaymentList, setAgentPaymentList] = useState([]);

    const getAllAgentPayment = async params => {
        try {

            setLoading(true);

            const res = await AgentPaymentService.getAllAgentPayment(params);
            setAgentPaymentList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <AgentPaymentContext.Provider
            value={{
                loading,
                totalElements,
                agentPaymentList,
                getAllAgentPayment,
            }}
        >
            {children}
        </AgentPaymentContext.Provider>
    );
}

export default AgentPaymentContextProvider;
